import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["overlay", "panel"];

  connect() {
    this._escHandler = (e) => {
      if (e.key === "Escape") this.close();
    };
  }

  disconnect() {
    document.removeEventListener("keydown", this._escHandler);
    document.body.classList.remove("overflow-hidden");
  }

  open(event) {
    if (event) event.preventDefault();
    this.overlayTarget.classList.remove("hidden");
    this.panelTarget.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
    document.addEventListener("keydown", this._escHandler);
  }

  close(event) {
    if (event) event.preventDefault();
    this.overlayTarget.classList.add("hidden");
    this.panelTarget.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
    document.removeEventListener("keydown", this._escHandler);
  }

  closeOnPanel(event) {
    if (event.target === this.panelTarget) {
      this.close(event);
    }
  }
}
